<template>
  <div>
    <el-dropdown @command="handleCommand">
      <span
        :class="{'cs-homeworkStatus': true,'cs-color-frenchgrey': data.HomeworkStatus <=1,'cs-redLabel':data.HomeworkStatus == 2, 'cs-color-green': data.HomeworkStatus == 3}"
      >
        <i v-if="data.HomeworkStatus == 3" class="fa fa-check-circle" aria-hidden="true"></i>
        <i v-if="data.HomeworkStatus == 2" class="fa fa-times-circle" aria-hidden="true"></i>
        <i v-if="data.HomeworkStatus <=1" class="fa fa-info-circle" aria-hidden="true"></i>
        {{data.HomeworkStatusText}}
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item :command="0" v-if="canEdit">未完成</el-dropdown-item>
        <el-dropdown-item :command="1" v-if="canEdit">已完成</el-dropdown-item>
        <!-- <el-dropdown-item :command="2" v-if="!canEdit">未提交无法修改</el-dropdown-item> -->
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<style lang="scss" scoped>
.cs-homeworkStatus{
    &:focus{
        outline: 0px solid transparent;
    }
}
</style>

<script>
import { updateStudentHomeworkIsCompleted } from "../../../service/homework.service";

export default {
  props: {
    data: {}
  },
  data() {
    return {
      homeworkStatus: -1,
      homeworkStatusText: "",
      canEdit: false,
      isCompleted: true,
      StatusList: ["未提交", "未完成", "已完成"],
      Id: 0
    };
  },
  components: {},
  created() {
    this.init();
  },
  methods: {
    init() {
      if (!!this.data) {
        this.isCompleted = this.data.IsCompleted;
        this.Id = this.data.Id;
        if (this.data.HasFile){
            this.canEdit = true;
        }else{
            this.canEdit = false;
        }
      }
    },
    handleCommand(command) {
      if (command == 2) return;
      let self = this;
      updateStudentHomeworkIsCompleted(this.data.Id, command).then(result => {
        if (!!result && result.success) {
          this.$message({
            type: "success",
            message: "更新成功!"
          });
          let data = {
            name: "statusChange"
          };
          this.$emit("customEvent", data);
        } else {
          this.$message({
            type: "error",
            message: "更新失败! " + result.message
          });
        }
      });
    }
  },
  watch: {
    data: function() {
      this.init();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/paginationCells/homeworkIsCompletedCell.vue